import {
  Modal,
  ModalOverlay,
  ModalContent,
  ModalCloseButton,
  ModalBody,
  Image,
} from "@chakra-ui/react";
import { CloseIcon } from "@chakra-ui/icons";
import React, { useState, useEffect } from "react";

const ImageModal = (props) => {
  const [isOpen, setIsOpen] = useState(props.isOpen);
  useEffect(() => {}, []);

  const handleClose = () => {
    props.handleClose();
    setIsOpen(false);
  };

  return (
    <Modal
      data-testid="scq-image-modal"
      isOpen={isOpen}
      onClose={handleClose}
      size="xl"
    >
      <ModalOverlay />
      <ModalContent sx={{ bgColor: "white" }}>
        <ModalCloseButton
          position="absolute"
          top={4}
          right={4}
          onClick={handleClose}
          icon={<CloseIcon color="white" />}
        />
        <ModalBody
          height="100%"
          display="flex"
          flexDirection="column"
          justifyContent="center"
          alignItems="center"
        >
          <Image
            src={props.url}
            alt="modal-image"
            w="70%"
            h="70%"
            maxW="100%"
            maxH="100vh"
            mx="auto"
            mt={10}
            mb={4}
          />
        </ModalBody>
      </ModalContent>
    </Modal>
  );
};
export default ImageModal;
